import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";

import QRCode from "react-qr-code";

export default class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrcode: `B11D76CBE405489F
D7AADC9F9A3AA3E3
BB2C8A8702168645
49CEBE6151AEE382
F8422695355DF4FB
C14FD298858152D1
033FF306E3D91EC8
F9EFD0921B65F1A0
936F6C0B0F5C9C7F
68C700E4D7CC90F8
D3FABE482086249E
854DDBC7FC5E849A
4D18E20162E3AD12
AA24E1F45F891CE8
93FB94F3614E1276
ED41681F2E2EAC5A
2FEF3D5A82BFE6A4
C70A6024244223BB
E54FDB643017BFB0
5E50FB1C0B9EE9BC
F68ED16BF20C0ED6
BC2817CFC73BE2C9
61D2A6936AA9E271
F5AB29A6658409D1
C7BC34CC535CC9A0`,
      select_qr: -1,
    };
  }

  async componentDidMount() {
    loading(false);
  }
  render() {
    const { qrcode, select_qr } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <textarea
          rows={10}
          className="form-control w-100"
          placeholder="QR Code..."
          onChange={(e) => {
            this.setState({ qrcode: e.target.value });
          }}
          value={qrcode}
        />
        <div className="d-flex flex-wrap gap-3">
          {qrcode
            .split("\n")
            .filter((e) => e)
            .map((e,i) => (
              <div className="px-3 pt-3 pb-5 pointer"
              style={{opacity: select_qr === i ? 1 : 0.05}}
              onMouseEnter={() => {
                this.setState({select_qr: i})
              }}
              onMouseLeave={() => {
                this.setState({select_qr: -1})
              }}

              >
                <QRCode
                  size={256}
                  style={{
                    height: 200,
                    width: 200,
                  }}
                  value={e}
                  viewBox={`0 0 256 256`}
                />
                <div className="mt-1 text-center w-100">{e}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
